<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
      width="1050px"
    >
      <div class="card">
        <div
          class="col-lg-12 list-header fix-header clearfix"
          style="display:flex;justify-content:flex-end"
        >
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="pageParams.content"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="ID、账号、手机号"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="search()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="app-list-sort">
            <b-dropdown>
              <template v-slot:button-content>
                <sort-icon />
              </template>
              <b-dropdown-item
                v-for="(item, index) in sortList"
                :key="index"
                @click="listSort(item)"
              >
                <span class="pull-left" v-if="pageParams.sortBy == item.value">
                  <i
                    v-if="pageParams.order == 'desc'"
                    class="bx bx-down-arrow-alt font-size-18 pull-left"
                  ></i>
                  <i
                    v-if="pageParams.order == 'asc'"
                    class="bx bx-up-arrow-alt font-size-18"
                  ></i>
                </span>
                <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                  item.text
                }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>

        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <div>
              <table class="table align-middle table-nowrap table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col" style="width: 70px;">
                      <b-form-checkbox
                        @change="checkedAll"
                        v-model="indeterminate"
                        checked
                        plain
                      ></b-form-checkbox>
                    </th>
                    <th scope="col" style="width: 50px;">ID</th>
                    <th scope="col">账号</th>
                    <th scope="col">姓名</th>
                    <th scope="col">手机</th>
                    <th scope="col">角色</th>
                    <th scope="col">状态</th>
                    <th scope="col">创建时间</th>
                  </tr>
                </thead>
                <tbody style="position:relative">
                  <tr v-if="showLoading">
                    <div class="xb-loading">
                      <app-list-loading
                        ref="loading"
                        :visible="showLoading"
                      ></app-list-loading>
                    </div>
                  </tr>
                  <tr v-for="item in items" :key="item.id">
                    <td>
                      <b-form-checkbox
                        v-model="choiceListIds"
                        :value="item.id"
                        checked
                        plain
                      ></b-form-checkbox>
                    </td>
                    <td>{{ item.id }}</td>
                    <td>
                      <div
                        style="max-width:200px;text-wrap:normal;word-break:break-all"
                      >
                        {{ item.userName }}
                      </div>
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.phone || "--" }}</td>
                    <td>{{ item.roleName || "--" }}</td>
                    <td>
                      <span v-if="item.state == 1"> 启用</span>
                      <span v-else>禁用 </span>
                    </td>
                    <td>{{ item.createdAt || "--" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- <pagination
          ref="page"
          @pageCallback="pageCallback"
          
        ></pagination> -->
        <pagination
          :isBatch="false"
          :total="pageTotal"
          :pageSize="pageParams.pageSize"
          :page.sync="pageParams.page"
          :pageSizes="[10, 20, 30]"
          @pageCallback="pageCallback"
          ref="page"
        ></pagination>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
// import recommend from "@/server/api/recommend";
import pagination from "@/components/pagination/pagination.vue";
// import api from "@/server/api/account";
import tags from "@/server/api/tags";
import mediaApi from "@/server/api/media";

export default {
  components: { pagination },

  data() {
    return {
      showLoading: false,
      pageTotal: 0,
      pageParams: {
        page: 1,
        pageSize: 10,
        // showState: 1,
        // tagId: "",
        sortBy: "",
        order: "",
        content: "",
        mediaId: undefined,
      },
      tagId: "",
      currentTag: "",
      items: [],
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      show: false,
      sortList: [
        // { text: "阅读", value: "viewNum" },
        // { text: "评论", value: "commentNum" },
        { text: "创建日期", value: "createTime" },
      ],
      searchTagName: "",
      searchTagList: [],
    };
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    title: {
      type: String,
      default: "添加人员",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
    visible: function() {
      if (this.visible) {
        this.getList();

        this.show = true;
      } else {
        this.show = false;
        this.choiceListIds = [];
      }
    },
  },

  mounted() {
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    // this.tagSearch()
    this.getList();
  },

  methods: {
    showModel() {
      let that = this;
      setTimeout(function(argument) {
        that.resetParams();
      }, 500);
      this.show = true;
    },

    handleClose() {
      this.show = false;
      this.$emit("change", false);
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
        // if (obj.ps == 100) {
        //   this.pageParams.pageSize = 100;
        //   this.getList();
        // } else if (obj.ps == 50) {
        //   this.pageParams.pageSize = 50;
        //   this.getList();
        // } else {
        //   this.pageParams.pageSize = 30;
        //   this.getList();
        // }
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
    },

    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams);
      // params.type = 2; // 0:草稿，1:初遍池，2：文章列表
      // this.$refs.loading.show();
      this.showLoading = true;
      console.log("选择人员搜索参数", params);

      mediaApi.mediaUserSelectList(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            console.log("选择列表", resp.data);
            this.choiceListIds = [];
            this.allListIds = [];
            this.items = resp.data.items;

            this.pageTotal = resp.data.total;
            if (this.pageTotal > 0) {
              resp.data.items.forEach((item) => {
                this.allListIds.push(item.id);
              });
            }
            this.showLoading = false;
            // this.showLoad=ing = false;
            // let pages = {
            //   page: resp.data.page, //第几页
            //   pageSize: resp.data.pageSize, //每页多少条
            //   total: resp.data.total, //全部有多少条数据
            //   totalPages: resp.data.totalPages, //全部有几页
            // };
          }
        }
      });
    },

    selectTags() {
      this.pageParams.tagId = this.currentTag.toString();
      this.getList();
    },

    submitCreate() {
      if (this.choiceListIds.length) {
        this.$emit("change", this.choiceListIds);
      } else {
        Vue.swal("请选择要添加的内容");
        return;
      }
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.content = "";
      this.pageParams.sortBy = "";
      this.pageParams.order = "";
      this.getList();
    },

    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "asc"; //默认正序
      }
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },
    //标签搜索
    tagSearch() {
      let params = {
        page: 1,
        pageSize: 20,
        type: 0, // 0内容标签  1用户标签
        name: this.searchTagName, // 非必需，搜索的时候用
      };
      tags.list(params).then((resp) => {
        console.log(resp);
        if (resp.data) {
          if (resp.data.items[0]) {
            this.searchTagList = resp.data.items;
          } else {
            Vue.swal({
              icon: "warning",
              title: "未搜索到相关标签，请重新输入！",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        }
      });
    },
  },
};
</script>
